import { useQuery } from '@tanstack/react-query';
import { Encounter } from 'src/models';
import { ambientApi, api } from 'src/services';
import { UseQueryOverrideOptions } from '../common';

export type UseGetEncounterDetailsParams = {
  encounterId: string;
};

export type GetEncounterDetailsResponse = Encounter;

export const useGetEncounterDetails = (
  { encounterId }: UseGetEncounterDetailsParams,
  options: UseQueryOverrideOptions<GetEncounterDetailsResponse> = {}
) => {
  return useQuery({
    ...options,
    queryKey: ['encounterDetails', encounterId],
    queryFn: () =>
      ambientApi
        .get<GetEncounterDetailsResponse>(`/encounters/${encounterId}`)
        .then((res) => res.data),
  });
};

export type UseGetEncounterChatHistoryParams = {
  encounterId: string;
};

export type GetEncounterChatHistoryResponse = {
  chat_message: {
    classification?: null;
    content: string;
    flagged?: boolean;
    phase?: 'chat';
    role: 'assistant' | 'user';
    timestamp: string;
    trace_id: string;
    asset?: {
      type: 'youtube_video';
      url: string;
    };
  }[];
  progress: number;
};

export const useGetEncounterChatHistory = ({
  encounterId,
}: UseGetEncounterChatHistoryParams) => {
  return useQuery({
    queryKey: ['encounter', encounterId, 'chatHistory'],
    queryFn: () =>
      api
        .get<GetEncounterChatHistoryResponse>(
          `/v3/encounter/${encounterId}/chat_history`
        )
        .then(({ data }) => {
          const { chat_message = [], progress = 0 } = data || {};
          return {
            chatMessage: chat_message,
            progress,
          };
        }),
  });
};
